import { Association, OrganizationManager } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Filter, Relations } from "remult";
import { TimeReportEntityConfig } from "./config";
import { TimeReportFilters } from "./filters";
import { TimeReportMethods } from "./methods";

@HyperEntity("time-report", TimeReportEntityConfig)
export class TimeReport extends extender(TimeReportFilters, TimeReportMethods) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Fields.string({ dbName: "association" })
  associationId = "";

  @Relations.toOne<TimeReport, Association>(() => Association, {
    caption: "מדווח/ת",
    fields: { id: "associationId" },
  })
  association?: Association;

  @Fields.string({ dbName: "organization_manager_id" })
  organizationManagerId = "";

  @Relations.toOne<TimeReport, OrganizationManager>(() => OrganizationManager, {
    caption: "מנהל/ת",
    field: "organizationManagerId",
  })
  organizationManager?: OrganizationManager;

  @Fields.boolean({
    defaultValue: () => false,
    dbName: "is_confirmed",
    valueConverter: {
      displayValue: (val) => (val ? "כן" : "לא"),
    },
    caption: "האם אושר?",
  })
  isConfirmed = false;

  @Fields.date<TimeReport>({
    caption: "תאריך ההתנדבות",
    displayValue: (v) => v.date.toLocaleDateString("he"),
  })
  date: Date = new Date();

  @Fields.number<TimeReport>({
    dbName: "hour_count",
    caption: "מספר שעות",
    displayValue: (v) => v.hourCount.toFixed(2),
  })
  hourCount = 0;

  @Fields.createdAt({
    dbName: "created_at",
  })
  createdAt: Date = new Date();

  @Fields.updatedAt({
    dbName: "updated_at",
  })
  updatedAt: Date = new Date();

  @Fields.string({ caption: "הערות" })
  comments = "";

  static isUserNameMatchValue = Filter.createCustom<
    TimeReport,
    { searchValue: string }
  >(({ searchValue }) => {
    return TimeReport.hyperFilter({
      association: {
        $is: { user: { $is: { name: { $contains: searchValue } } } },
      },
    });
  });
}
